module.exports = __webpack_public_path__ + "static/icon_studies-navy-50bc3fb355c8b2b58b637c1bd96230c8.png";